import './product.scss';
import '../shared/ebc-datepicker.scss';
import { initFlatpickr } from '../shared/flatpickr-init';

jQuery(document).ready(function () {
	const { booked_dates, options } = devnet_ebc_script_data;

	initFlatpickr('#ebc-date-field', {
		inline: true,
		clientDateFormat: 'd.m.Y',
		locale: 'hr',
		booked_dates,
		onChange(selectedDates) {
			// Custom logic for admin
		},
	});
});
